var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"6","y":"9","width":"20","height":"2","rx":"1","fill":"#323649","key":0}),React.createElement("rect",{"x":"6","y":"15","width":"20","height":"2","rx":"1","fill":"#323649","key":1}),React.createElement("rect",{"x":"6","y":"15","width":"20","height":"2","rx":"1","fill":"#323649","key":2}),React.createElement("rect",{"x":"6","y":"21","width":"20","height":"2","rx":"1","fill":"#323649","key":3})]);
}

Burger.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Burger;

Burger.default = Burger;
